var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticStyle: { "margin-bottom": "35px" } },
    [
      _c("AppBar"),
      _c("Footer"),
      _c(
        "v-snackbar",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error.msg !== "",
              expression: "error.msg !== ''",
            },
          ],
          attrs: { top: "", right: "", color: "red" },
          model: {
            value: _vm.error.status,
            callback: function ($$v) {
              _vm.$set(_vm.error, "status", $$v)
            },
            expression: "error.status",
          },
        },
        [
          _c("v-icon", [_vm._v("mdi-alert-outline")]),
          _vm._v(" " + _vm._s(_vm.error.msg) + " "),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.success.msg !== "",
              expression: "success.msg !== ''",
            },
          ],
          attrs: { top: "", right: "", color: "success" },
          model: {
            value: _vm.success.status,
            callback: function ($$v) {
              _vm.$set(_vm.success, "status", $$v)
            },
            expression: "success.status",
          },
        },
        [
          _c("v-icon", [_vm._v("mdi-checkbox-marked-circle-outline")]),
          _vm._v(" " + _vm._s(_vm.success.msg) + " "),
        ],
        1
      ),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }